import type { UUID } from "utils";

const BASE_URL = "/stablecoins";
const WALLETS_URL = `${BASE_URL}/wallets`;
const WALLETS_BENEFICIARIES_URL = `${WALLETS_URL}/beneficiaries`;
const WALLETS_BANK_ACCOUNTS_URL = `${WALLETS_URL}/bank-accounts`;
const WALLETS_CRYPTO_WALLETS_URL = `${WALLETS_URL}/crypto-wallets`;

export const URL_PARAMS = {
  CONFIGURE: "configure",
} as const;

export const CONFIGURE_PARAM_VALUES = {
  DESTINATION: "destination",
  RESERVE: "reserve",
  SCHEDULE: "schedule",
} as const;

export const PAGE_URLS = {
  onboarding: `${BASE_URL}/onboarding`,
  payments: `${BASE_URL}/payments`,
  paymentDetails: `${BASE_URL}/payments/:id`,
  settlements: `${BASE_URL}/settlements`,
  settlementDetails: `${BASE_URL}/settlements/:settlementId`,
  wallets: WALLETS_URL,
  walletsBeneficiaries: WALLETS_BENEFICIARIES_URL,
  walletsBankAccounts: WALLETS_BANK_ACCOUNTS_URL,
  walletsCryptoWallets: WALLETS_CRYPTO_WALLETS_URL,
  walletsBeneficiaryNew: `${WALLETS_BENEFICIARIES_URL}/new`,
  walletsBeneficiaryEdit: `${WALLETS_BENEFICIARIES_URL}/:beneficiaryId/edit`,
  walletsBankAccountNew: `${WALLETS_BANK_ACCOUNTS_URL}/new`,
  walletsBankAccountEdit: `${WALLETS_BANK_ACCOUNTS_URL}/:bankAccountId/edit`,
  walletsCryptoWalletNew: `${WALLETS_CRYPTO_WALLETS_URL}/new`,
  walletsCryptoWalletEdit: `${WALLETS_CRYPTO_WALLETS_URL}/:cryptoWalletId/edit`,
  walletDetails: `${WALLETS_URL}/:walletId`,
  walletSettlementSettings: `${WALLETS_URL}/:walletId/settlement`,
  walletSettlementConfigure: `${WALLETS_URL}/:walletId/settlement/configure`,
  getLinkToPaymentDetails: (fiatTxId: UUID) =>
    `${BASE_URL}/payments/${fiatTxId}`,
  getLinkToSettlementDetails: (settlementId: UUID) =>
    `${BASE_URL}/settlements/${settlementId}`,
  getLinkToBeneficiaryEdit: (beneficiaryId: UUID) =>
    `${WALLETS_BENEFICIARIES_URL}/${beneficiaryId}/edit`,
  getLinkToBankAccountEdit: (bankAccountId: UUID) =>
    `${WALLETS_BANK_ACCOUNTS_URL}/${bankAccountId}/edit`,
  getLinkToCryptoWalletEdit: (cryptoWalletId: UUID) =>
    `${WALLETS_CRYPTO_WALLETS_URL}/${cryptoWalletId}/edit`,
  getLinkToWalletDetails: (walletId: UUID) => `${WALLETS_URL}/${walletId}`,
  getLinkToWalletSettlementSettings: (walletId: UUID) =>
    `${WALLETS_URL}/${walletId}/settlement`,
  getLinkToWalletSettlementConfigure: (walletId: UUID) =>
    `${WALLETS_URL}/${walletId}/settlement/configure`,
  getLinkToWalletSettlementReserve: (walletId: UUID) =>
    `${WALLETS_URL}/${walletId}/settlement?${URL_PARAMS.CONFIGURE}=${CONFIGURE_PARAM_VALUES.RESERVE}`,
  getLinkToWalletSettlementSchedule: (walletId: UUID) =>
    `${WALLETS_URL}/${walletId}/settlement?${URL_PARAMS.CONFIGURE}=${CONFIGURE_PARAM_VALUES.SCHEDULE}`,
  getLinkToWalletSettlementDestination: (walletId: UUID) =>
    `${WALLETS_URL}/${walletId}/settlement?${URL_PARAMS.CONFIGURE}=${CONFIGURE_PARAM_VALUES.DESTINATION}`,
} as const;
